var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.931 12.5345H1.72414C1.26687 12.5345 0.828327 12.3529 0.504988 12.0296C0.18165 11.7062 0 11.2677 0 10.8104V2.18971C0 1.73244 0.18165 1.2939 0.504988 0.970565C0.828327 0.647226 1.26687 0.465576 1.72414 0.465576H12.931C13.3883 0.465576 13.8268 0.647226 14.1502 0.970565C14.4735 1.2939 14.6552 1.73244 14.6552 2.18971V10.8104C14.6552 11.2677 14.4735 11.7062 14.1502 12.0296C13.8268 12.3529 13.3883 12.5345 12.931 12.5345Z",
    fill: "#FF7B29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecap);
export default __webpack_public_path__ + "static/media/recap.78085eb25903de88cfd5f2351326ac5b.svg";
export { ForwardRef as ReactComponent };